import { __assign, __awaiter, __generator } from "tslib";
import axios from 'axios';
var AnexApiClient = (function () {
    function AnexApiClient(anexApiBaseUrl, anexApiToken) {
        if (anexApiToken === void 0) { anexApiToken = null; }
        this._jwt = null;
        this._httpClient = axios.create({ baseURL: anexApiBaseUrl });
        if (anexApiToken) {
            this.Jwt = anexApiToken;
        }
    }
    Object.defineProperty(AnexApiClient.prototype, "Jwt", {
        get: function () {
            return this._jwt;
        },
        set: function (value) {
            this._jwt = value;
        },
        enumerable: true,
        configurable: true
    });
    AnexApiClient.Request = function (jwt, anexApiBaseUrl) {
        if (jwt === void 0) { jwt = null; }
        var api = new AnexApiClient(anexApiBaseUrl);
        api.Jwt = jwt;
        return api;
    };
    AnexApiClient.prototype._authenticateRequest = function (config) {
        if (this.Jwt === null)
            return config;
        if (typeof config['headers'] !== 'object')
            config['headers'] = {};
        if (typeof config['headers']['X-Access-Token'] !== 'string') {
            config['headers']['X-Access-Token'] = this.Jwt;
        }
        return config;
    };
    AnexApiClient.prototype._injectQueryParameter = function (key, value, config) {
        if (value === '' || value === null)
            return config;
        if (typeof config['params'] !== 'object')
            config['params'] = {};
        if (!config['params'].hasOwnProperty(key)) {
            config['params'][key] = value;
        }
        return config;
    };
    Object.defineProperty(AnexApiClient.prototype, "V1", {
        get: function () {
            var _this = this;
            return {
                Templates: {
                    Render: function (template, wholesaleCustomerCode, templateType, dto, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/templates/render', config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                },
                ServiceQualification: {
                    Nbn: {
                        ByAddress: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/service-qualification/nbn/by-address', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Mobile: {
                        ByAddress: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/service-qualification/mobile/by-address', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Energy: {
                        ByPostCode: function (postCode, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('postCode', postCode, config);
                                            return [4, this._httpClient.get('/api/v1/service-qualification/energy/by-post-code', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Index: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/service-qualification/energy', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Dsl: {
                        ByAddress: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/service-qualification/dsl/by-address', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                },
                Sale: {
                    Product: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/sale/product', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    Order: {
                        Summary: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/sale/order/summary', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Energy: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/sale/energy', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    Broadband: {
                        Index: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/sale/broadband', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        RegisterDetails: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/sale/broadband/register-details', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Terms: function (contractCode, hardwareCode, nbnLocId, voipCode, voipPortNumberFlag, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('hardwareCode', hardwareCode, config);
                                            config = this._injectQueryParameter('nbnLocId', nbnLocId, config);
                                            config = this._injectQueryParameter('voipCode', voipCode, config);
                                            config = this._injectQueryParameter('voipPortNumberFlag', voipPortNumberFlag, config);
                                            return [4, this._httpClient.get("/api/v1/sale/broadband/terms/" + encodeURIComponent(contractCode), config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Quote: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/sale/broadband/quote', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Mobile: {
                        Index: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/sale/mobile', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Voip: {
                        Index: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/sale/voip', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                },
                Superloop: {
                    Nbn: {
                        LocationSearch: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config['params'] = __assign({}, request);
                                            return [4, this._httpClient.get("/api/v1/superloop/location-search", config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        QualifyByLocationId: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/superloop/service-qualification', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Diagnostics: {
                            Index: function (serviceID, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('serviceId', serviceID, config);
                                                return [4, this._httpClient.get('/api/v1/superloop/diagnostics', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            CreateTest: function (serviceID, testType, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('serviceId', serviceID, config);
                                                config = this._injectQueryParameter('testType', testType, config);
                                                return [4, this._httpClient.get('/api/v1/superloop/diagnostics/create-test', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            History: function (serviceID, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('serviceId', serviceID, config);
                                                return [4, this._httpClient.get('/api/v1/superloop/diagnostics/history', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                    },
                },
                Reports: {
                    Nbn: {
                        Services: function (format, isActive, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('isActive', isActive, config);
                                            return [4, this._httpClient.get("/api/v1/reports/nbn/services." + encodeURIComponent(format), config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Usage: function (format, year, month, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('year', year, config);
                                            config = this._injectQueryParameter('month', month, config);
                                            return [4, this._httpClient.get("/api/v1/reports/nbn/usage." + encodeURIComponent(format), config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Financial: function (format, fromDate, toDate, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        config = this._injectQueryParameter('fromDate', fromDate, config);
                                        config = this._injectQueryParameter('toDate', toDate, config);
                                        return [4, this._httpClient.get("/api/v1/reports/financial/failed-payments." + encodeURIComponent(format), config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                },
                Mobile: {
                    InitiateEmailVerification: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/mobile/initiate-email-verification', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    HandleEmailVerification: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/mobile/handle-email-verification', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    InitiatePortInVerification: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/mobile/initiate-port-in-verification', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    SubmitActivation: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/mobile/submit-activation', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    ValidatePortInVerification: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/mobile/validate-port-in-verification', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                },
                Management: {
                    TestDataEntry: {
                        UsageDataEntry: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/management/test-data-entry/usage-data-entry', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Settings: {
                        StaticIps: {
                            Unassign: function (request, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('request', request, config);
                                                return [4, this._httpClient.post('/api/v1/management/settings/static-ips/unassign', request, config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Assign: function (request, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.post('/api/v1/management/settings/static-ips/assign', request, config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                    },
                    Jobs: {
                        Voip: {
                            Vocus: {
                                ImportCdrFilesFromS3: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/voip/vocus/import-cdr-files-from-s3', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                CopyCdrFilesToS3: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/voip/vocus/copy-cdr-files-to-s3', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                            Engin: {
                                ImportCdrFilesFromS3: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/voip/engin/import-cdr-files-from-s3', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                CopyCdrFilesToS3: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/voip/engin/copy-cdr-files-to-s3', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                        },
                        Users: {
                            ExpiredPasswordNotificationJob: function (jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/users/expired-password-notification-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        Tasks: {
                            TriggerReceiveTaskEmailsCronJob: function (jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/tasks/trigger-receive-task-emails-cron-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        Services: {
                            TriggerUsageAlertNotificationJob: function (serviceId, periodStart, thresholdBreached, totalAllowedUsageBytes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/services/trigger-usage-alert-notification-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            TriggerDataLimitCronJob: function (thresholds, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.post('/api/v1/management/jobs/services/trigger-data-limit-cron-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            TriggerCompletePendingCancelationJob: function (jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/services/trigger-complete-pending-cancelation-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            TriggerScheduleGasUsageJobCronJob: function (config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.post('/api/v1/management/jobs/services/trigger-schedule-gas-usage-job-cron-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            TriggerElectricityUsageCronJob: function (config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.post('/api/v1/management/jobs/services/trigger-electricity-usage-cron-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        Reports: {
                            ServiceQualificationReportJobController: function (jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/reports/service-qualification-report-job-controller', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        Radius: {
                            UserSyncJob: function (serviceIdentifier, jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get("/api/v1/management/jobs/radius/user-sync-job/" + encodeURIComponent(serviceIdentifier), config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            UsersSyncJob: function (jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/radius/users-sync-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            ContractSyncJob: function (wholesaleCustomerCode, contractCode, jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get("/api/v1/management/jobs/radius/contract-sync-job/" + encodeURIComponent(wholesaleCustomerCode) + "/" + encodeURIComponent(contractCode), config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            ContractsSyncJob: function (jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/radius/contracts-sync-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        Nbn: {
                            ImportCsv: function (csvFile, queue, seed, jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('queue', queue, config);
                                                config = this._injectQueryParameter('seed', seed, config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get("/api/v1/management/jobs/nbn/import-csv/" + encodeURIComponent(csvFile), config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            ExtractZip: function (zipFile, queue, seed, jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('queue', queue, config);
                                                config = this._injectQueryParameter('seed', seed, config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get("/api/v1/management/jobs/nbn/extract-zip/" + encodeURIComponent(zipFile), config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            DownloadZip: function (jobId, seed, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                config = this._injectQueryParameter('seed', seed, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/nbn/download-zip', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        Issues: {
                            TriggerReceiveIssueEmailsCronJob: function (jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/issues/trigger-receive-issue-emails-cron-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        Billing: {
                            Payments: {
                                Index: function (accountId, jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get("/api/v1/management/jobs/billing/payments/" + encodeURIComponent(accountId), config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                TriggerPaymentsCron: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/billing/payments/trigger-payments-cron', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                TriggerPaymentReminderJob: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/billing/payments/trigger-payment-reminder-job', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                TriggerFailedPaymentsListCron: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/billing/payments/trigger-failed-payments-list-cron', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                PendingPayments: function (to, atDate, jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('to', to, config);
                                                    config = this._injectQueryParameter('atDate', atDate, config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/billing/payments/pending-payments', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                            Invoices: {
                                Index: function (serviceId, jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get("/api/v1/management/jobs/billing/invoices/" + encodeURIComponent(serviceId), config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                TriggerInvoicesCron: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/billing/invoices/trigger-invoices-cron', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                TriggerInvoicesOverdueJob: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/billing/invoices/trigger-invoices-overdue-job', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                RecurringAllWhatIf: function (to, atDate, jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('to', to, config);
                                                    config = this._injectQueryParameter('atDate', atDate, config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/billing/invoices/recurring-all-what-if', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                            ContractCosts: {
                                TriggerContractCostsCron: function (jobId, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('jobId', jobId, config);
                                                    return [4, this._httpClient.get('/api/v1/management/jobs/billing/contract-costs/trigger-contract-costs-cron', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                        },
                        Account: {
                            TriggerRemoveAccountsWithoutServicesJob: function (jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/account/trigger-remove-accounts-without-services-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            TriggerCreditCardExpiringNotificationJob: function (jobId, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('jobId', jobId, config);
                                                return [4, this._httpClient.get('/api/v1/management/jobs/account/trigger-credit-card-expiring-notification-job', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                    },
                },
                Lookup: {
                    Payment: {
                        AvailablePaymentMethods: function (config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.get('/api/v1/lookup/payment/available-payment-methods', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Settings: function (config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.get('/api/v1/lookup/settings', config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    Products: {
                        Service: function (serviceCode, codes, productType, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('serviceCode', serviceCode, config);
                                            config = this._injectQueryParameter('codes', codes, config);
                                            config = this._injectQueryParameter('productType', productType, config);
                                            return [4, this._httpClient.get('/api/v1/lookup/products/service', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Hardware: function (codes, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('codes', codes, config);
                                            return [4, this._httpClient.get('/api/v1/lookup/products/hardware', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    NetworkStatus: function (config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.get('/api/v1/lookup/network-status', config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    Contracts: {
                        Voip: function (codes, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('codes', codes, config);
                                            return [4, this._httpClient.get('/api/v1/lookup/contracts/voip', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Mobile: function (codes, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('codes', codes, config);
                                            return [4, this._httpClient.get('/api/v1/lookup/contracts/mobile', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Energy: {
                            Gas: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/lookup/contracts/energy/gas', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Electricity: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/lookup/contracts/energy/electricity', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        Broadband: {
                            Nbn: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/lookup/contracts/broadband/nbn', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Uniti: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/lookup/contracts/broadband/uniti', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Dsl: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/lookup/contracts/broadband/dsl', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                    },
                    Address: {
                        UnitTypes: function (config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.get('/api/v1/lookup/address/unit-types', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        StreetTypes: function (config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.get('/api/v1/lookup/address/street-types', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        LevelTypes: function (config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.get('/api/v1/lookup/address/level-types', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        LotTypes: function (config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.get('/api/v1/lookup/address/lot-types', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        LocationStates: function (config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.get('/api/v1/lookup/address/location-states', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Account: {
                        Invoice: function (accountCode, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.get("/api/v1/lookup/account/invoice/" + encodeURIComponent(accountCode), config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                },
                CreditCard: {
                    TokenReceipt: function (gatewayType, paymentType, request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, this._httpClient.post("/api/v1/credit-card/token-receipt/" + encodeURIComponent(gatewayType) + "/" + encodeURIComponent(paymentType), request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    TakePayment: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/credit-card/take-payment', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    AuthToken: function (gatewayType, paymentType, customerRef, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._injectQueryParameter('customerRef', customerRef, config);
                                        return [4, this._httpClient.get("/api/v1/credit-card/auth-token/" + encodeURIComponent(gatewayType) + "/" + encodeURIComponent(paymentType), config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                },
                Authentication: {
                    TestToken: function (config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.get('/api/v1/authentication/test-token', config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    RefreshToken: function (config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.get('/api/v1/authentication/refresh-token', config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    GetToken: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, this._httpClient.post('/api/v1/authentication/get-token', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    GetOssToken: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/authentication/get-oss-token', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    AuthenticateViaEmail: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, this._httpClient.post('/api/v1/authentication/authenticate-via-email', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                },
                Account: {
                    Transactions: function (from, to, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        config = this._injectQueryParameter('from', from, config);
                                        config = this._injectQueryParameter('to', to, config);
                                        return [4, this._httpClient.get('/api/v1/account/transactions', config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    Status: function (config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.get('/api/v1/account/status', config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    Services: {
                        Index: function (codes, types, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('codes', codes, config);
                                            config = this._injectQueryParameter('types', types, config);
                                            return [4, this._httpClient.get('/api/v1/account/services', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Voip: {
                            Index: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/account/services/voip', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Usage: function (serviceCode, from, to, uninvoiced, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('from', from, config);
                                                config = this._injectQueryParameter('to', to, config);
                                                config = this._injectQueryParameter('uninvoiced', uninvoiced, config);
                                                return [4, this._httpClient.get("/api/v1/account/services/voip/usage/" + encodeURIComponent(serviceCode), config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            UnbilledCdrs: function (config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.get('/api/v1/account/services/voip/unbilled-cdrs', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        Mobile: {
                            Usage: {
                                MonthlyUsage: function (serviceCode, year, month, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    return [4, this._httpClient.get("/api/v1/account/services/mobile/usage/monthly/" + encodeURIComponent(serviceCode) + "/" + encodeURIComponent(year) + "/" + encodeURIComponent(month), config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                            Sim: {
                                Validate: function (simNumber, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('simNumber', simNumber, config);
                                                    return [4, this._httpClient.get('/api/v1/account/services/mobile/sim/validate', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                            PersonalDetails: {
                                Verify: function (request, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    return [4, this._httpClient.post('/api/v1/account/services/mobile/personal-details/verify', request, config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                        },
                        Energy: {
                            Index: function (config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.get('/api/v1/account/services/energy', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Gas: {
                                Index: function (codes, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('codes', codes, config);
                                                    return [4, this._httpClient.get('/api/v1/account/services/energy/gas', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                Usage: function (serviceCode, skip, take, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('skip', skip, config);
                                                    config = this._injectQueryParameter('take', take, config);
                                                    return [4, this._httpClient.get("/api/v1/account/services/energy/gas/usage/" + encodeURIComponent(serviceCode), config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                            Electricity: {
                                Index: function (codes, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('codes', codes, config);
                                                    return [4, this._httpClient.get('/api/v1/account/services/energy/electricity', config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                Usage: {
                                    MonthlyUsage: function (serviceCode, year, month, config) {
                                        if (config === void 0) { config = {}; }
                                        return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        config = this._authenticateRequest(config);
                                                        return [4, this._httpClient.get("/api/v1/account/services/energy/electricity/usage/" + encodeURIComponent(serviceCode) + "/" + encodeURIComponent(year) + "/" + encodeURIComponent(month), config)];
                                                    case 1: return [2, (_a.sent()).data];
                                                }
                                            });
                                        });
                                    },
                                    Index: function (serviceCode, skip, take, config) {
                                        if (config === void 0) { config = {}; }
                                        return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        config = this._authenticateRequest(config);
                                                        config = this._injectQueryParameter('skip', skip, config);
                                                        config = this._injectQueryParameter('take', take, config);
                                                        return [4, this._httpClient.get("/api/v1/account/services/energy/electricity/usage/" + encodeURIComponent(serviceCode), config)];
                                                    case 1: return [2, (_a.sent()).data];
                                                }
                                            });
                                        });
                                    },
                                    YearlyUsage: function (serviceCode, year, config) {
                                        if (config === void 0) { config = {}; }
                                        return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        config = this._authenticateRequest(config);
                                                        return [4, this._httpClient.get("/api/v1/account/services/energy/electricity/usage/" + encodeURIComponent(serviceCode) + "/" + encodeURIComponent(year), config)];
                                                    case 1: return [2, (_a.sent()).data];
                                                }
                                            });
                                        });
                                    },
                                },
                            },
                        },
                        Broadband: {
                            Index: function (config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.get('/api/v1/account/services/broadband', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Usage: {
                                DailyUsage: function (serviceCode, year, month, day, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    return [4, this._httpClient.get("/api/v1/account/services/broadband/usage/" + encodeURIComponent(serviceCode) + "/" + encodeURIComponent(year) + "/" + encodeURIComponent(month) + "/" + encodeURIComponent(day), config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                MonthlyUsage: function (serviceCode, year, month, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    return [4, this._httpClient.get("/api/v1/account/services/broadband/usage/" + encodeURIComponent(serviceCode) + "/" + encodeURIComponent(year) + "/" + encodeURIComponent(month), config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                Index: function (serviceCode, year, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    config = this._injectQueryParameter('year', year, config);
                                                    return [4, this._httpClient.get("/api/v1/account/services/broadband/usage/" + encodeURIComponent(serviceCode), config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                YearlyUsage: function (serviceCode, year, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    return [4, this._httpClient.get("/api/v1/account/services/broadband/usage/" + encodeURIComponent(serviceCode) + "/" + encodeURIComponent(year), config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                                Hourly: function (serviceCode, year, config) {
                                    if (config === void 0) { config = {}; }
                                    return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    config = this._authenticateRequest(config);
                                                    return [4, this._httpClient.get("/api/v1/account/services/broadband/usage/hourly/" + encodeURIComponent(serviceCode) + "/" + encodeURIComponent(year), config)];
                                                case 1: return [2, (_a.sent()).data];
                                            }
                                        });
                                    });
                                },
                            },
                            Nbn: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/account/services/broadband/nbn', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Dsl: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/account/services/broadband/dsl', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                        IsInRadius: function (serviceID, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('serviceId', serviceID, config);
                                            return [4, this._httpClient.get('/api/v1/account/services/broadband/is-in-radius', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Orders: {
                        Hardware: {
                            Index: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/account/orders/hardware', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Modem: function (codes, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('codes', codes, config);
                                                return [4, this._httpClient.get('/api/v1/account/orders/hardware/modem', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                    },
                    Invoices: {
                        Summary: function (from, to, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('from', from, config);
                                            config = this._injectQueryParameter('to', to, config);
                                            return [4, this._httpClient.get('/api/v1/account/invoices/summary', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Full: {
                            Index: function (invoiceCode, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.get("/api/v1/account/invoices/full/" + encodeURIComponent(invoiceCode), config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Pdf: function (invoiceCode, download, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('download', download, config);
                                                return [4, this._httpClient.get("/api/v1/account/invoices/full/pdf/" + encodeURIComponent(invoiceCode), config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                    },
                    Create: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/account/create', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    Contacts: {
                        Index: function (contactTypes, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            config = this._injectQueryParameter('contactTypes', contactTypes, config);
                                            return [4, this._httpClient.get('/api/v1/account/contacts', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        UserDetails: function (config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.get('/api/v1/account/contacts/user-details', config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        Update: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/account/contacts/update', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    Communications: {
                        Emails: {
                            SendgridEvents: function (apiKey, sendgridEvents, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4, this._httpClient.post('/api/v1/account/communications/emails/sendgrid-events', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                    },
                    Actions: {
                        CancelContract: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/account/actions/cancel-contract', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        PaymentPlan: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/account/actions/payment-plan', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        UpdateCreditCard: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/account/actions/update-credit-card', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        SupportTicket: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/account/actions/support-ticket', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        MoveAddress: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/account/actions/move-address', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        ChangeContract: {
                            Index: function (request, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                return [4, this._httpClient.post('/api/v1/account/actions/change-contract', request, config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            EnergyContracts: function (serviceCode, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('serviceCode', serviceCode, config);
                                                return [4, this._httpClient.get('/api/v1/account/actions/change-contract/energy-contracts', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                            Contracts: function (serviceCode, config) {
                                if (config === void 0) { config = {}; }
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                config = this._authenticateRequest(config);
                                                config = this._injectQueryParameter('serviceCode', serviceCode, config);
                                                return [4, this._httpClient.get('/api/v1/account/actions/change-contract/contracts', config)];
                                            case 1: return [2, (_a.sent()).data];
                                        }
                                    });
                                });
                            },
                        },
                    },
                    Check: function (request, config) {
                        if (config === void 0) { config = {}; }
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        config = this._authenticateRequest(config);
                                        return [4, this._httpClient.post('/api/v1/account/check', request, config)];
                                    case 1: return [2, (_a.sent()).data];
                                }
                            });
                        });
                    },
                    Verify: {
                        Index: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/account/verify', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                        SaleQuote: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/account/verify/sale-quote', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                    SaleQuote: {
                        Summary: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v1/account/sale-quote/summary', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnexApiClient.prototype, "V2", {
        get: function () {
            var _this = this;
            return {
                Sale: {
                    Order: {
                        Summary: function (request, config) {
                            if (config === void 0) { config = {}; }
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this._authenticateRequest(config);
                                            return [4, this._httpClient.post('/api/v2/sale/order/summary', request, config)];
                                        case 1: return [2, (_a.sent()).data];
                                    }
                                });
                            });
                        },
                    },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    return AnexApiClient;
}());
export { AnexApiClient };
//# sourceMappingURL=AnexApiClient.js.map